import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { i18n } from '@fs/zion-locale'
import { AppLayout, colors } from '@fs/zion-ui'
import { useFeatureFlag } from '@fs/zion-flags'
import { appPath } from '@fs/zion-config'
import HomePageHeader from './HomePageHeader'
import HomePageBody from './HomePageBody'
import HomePageFooter from './HomePageFooter'
import PageHead from '../PageHead'
import shareImage from './assets/share-image.png'

export default function HomePage(): JSX.Element | null {
  const [t] = useTranslation()
  const isLangCodeFromFrontierOn = useFeatureFlag('shared_addLangCodeToUrl').isOn
  const pageTitle = t('ancestors.home.meta-data.title')
  const pageDescription = t('ancestors.home.meta-data.description')
  const socialShareDescription = t('ancestors.home.meta-data.social-share-description')
  const image = { url: shareImage, alt: pageTitle, width: 1024, height: 560 }
  const pageUrl = isLangCodeFromFrontierOn ? appPath : `${window.location.origin}/${i18n.language}/`

  usePageView({ page_detail: 'Home' })

  if (!isLangCodeFromFrontierOn && !process.env.SSR && window?.location?.pathname === '/') {
    // Can't use history.push:
    window.location.href = `/${i18n.language}/`
    return null
  }

  return (
    <AppLayout fullWidth backgroundColor={colors.gray00}>
      <PageHead
        title={pageTitle}
        description={pageDescription}
        socialShareDescription={socialShareDescription}
        url={pageUrl}
        image={image}
      />
      <HomePageHeader />
      <HomePageBody />
      <HomePageFooter />
    </AppLayout>
  )
}
